import i18n from '@/langs/i18n.js';

export default function () {
  return {
    header: [
      {
        label: i18n.t('advisersFinder.theFinanceExpert'),
        url: 'eksperci-finansowi'
      },
      {
        label: i18n.t('pageLinks.howThisWorks'),
        url: 'jak-to-dziala',
      },
      {
        label: i18n.t('pageLinks.tutorials'),
        url: 'blog',
      },
    ],
    offerComparison: {
      label: i18n.t('pageLinks.compareCreditOffers'),
      url: 'porownaj-oferty'
    },
    expertSearch: {
      label: i18n.t('pageLinks.findTheBestExpert'),
      url: 'wybierz-eksperta'
    },
    footer: [
      {
        label: i18n.t('pageLinks.tutorials'),
        url: 'blog',
      },
      {
        label: i18n.t('pageLinks.collaboration'),
        url: 'wspolpraca',
      },
      {
        label: i18n.t('pageLinks.contact'),
        url: 'kontakt',
      },
      {
        label: i18n.t('customerAgreementsForm.consent.termsTitle'),
        url: 'regulamin',
      },
      {
        label: i18n.t('customerAgreementsForm.consent.privacyPolicyTitle'),
        url: 'polityka-prywatnosci',
      },
    ],
    facebookUrl: 'https://www.facebook.com/FinHubPL/',
    linkedInUrl: 'https://www.linkedin.com/company/finhub-pl/',
    privacyPolicy: 'polityka-prywatnosci',
    regulations: 'regulamin',
    privacyPolicyForExpert: 'polityka-prywatnosci-partnera',
    regulationsForExpert: 'regulamin-partnera',
  };
}
